export default "__VITE_ASSET__6cb29a37__"